/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRampLeft3 = createReactComponent("outline", "arrow-ramp-left-3", "IconArrowRampLeft3", [["path", { "d": "M18 3v6", "key": "svg-0" }], ["path", { "d": "M8 16l-4 -4l4 -4", "key": "svg-1" }], ["path", { "d": "M18 21v-6a3 3 0 0 0 -3 -3h-11", "key": "svg-2" }]]);

export { IconArrowRampLeft3 as default };
//# sourceMappingURL=IconArrowRampLeft3.mjs.map
